import AdvertisementPage from "pages/Advertisement";
import AuthenPage from "pages/Authen";
import CartPage from "pages/Cart";
import CheckoutPage from "pages/Checkout";
import ForgetPasswordPage from "pages/ForgetPassword";
import Home from "pages/Home";
import OrderDetailPage from "pages/OrderDetail";
import ProductPage from "pages/Product";
import RedemptionPage from "pages/Redemption";
import RegisterSuccessPage from "pages/RegisterSuccess";
import PointsHistoryPage from "pages/PointsHistory";
import ReturnPolicy from "pages/ReturnPolicy";
import SearchPage from "pages/SearchProduct";
import SettingPage from "pages/Setting";
import WhyBuyFrom from "pages/WhyBuyFrom";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/product/:id",
    element: <ProductPage />,
  },
  {
    path: "/authen",
    element: <AuthenPage />,
  },
  {
    path: "/forgetpassword",
    element: <ForgetPasswordPage />,
  },
  {
    path: "/register-success",
    element: <RegisterSuccessPage />,
  },
  {
    path: "/cart",
    element: <CartPage />,
  },
  {
    path: "/search",
    element: <Home />,
  },
  {
    path: "/search/:productName",
    element: <SearchPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/orderDetail/:orderId",
    element: <OrderDetailPage />,
  },
  {
    path: "/setting/:tab",
    element: <SettingPage />,
  },
  {
    path: "/why-2-buy",
    element: <WhyBuyFrom />,
  },
  {
    path: "/return-policy",
    element: <ReturnPolicy />,
  },
  {
    path: "/capsule-market",
    element: <RedemptionPage />,
  },
  {
    path: "/points-history",
    element: <PointsHistoryPage />,
  },
  {
    path: "/ad/:id",
    element: <AdvertisementPage />,
  },
]);

function NarinRouter() {
  return <RouterProvider router={router} />;
}

export default NarinRouter;
